'use strict';

var _ = require('lodash');
var FlightLevelChartController = function FlightLevelChartController(scope, BrushSelectionFilter, analysisMetricService, dataRetrieverService, dataRetrieverConstantsService, rangesCalculatorService, dataProviderService, $filter, formatterService, visibilityManager, currentStateCriteriaService, representationService) {
  var analysisMetric = analysisMetricService.getAnalysisMetric(scope.screen);
  var labels = analysisMetric.getAvailableLabels(scope.mode);
  var modesToListen = [{
    event: scope.screen + '-' + 'cabin',
    modeName: 'cabin'
  }, {
    event: scope.screen + '-' + 'cabin-da',
    modeName: 'cabin-da'
  }, {
    event: scope.screen + '-' + 'cabin-post-departure',
    modeName: 'cabin-post-departure'
  }];
  scope.ranges = [];
  scope.metrics = analysisMetric.getMetricValues(scope.mode);
  scope.selectedMetric = _.find(labels, {
    id: analysisMetric.getDefault()
  });
  scope.selectedDate = null;
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  var tooltipFlightTemplate = _.template(require('../templates/flight-tooltip-template.html'));
  scope.onBrushFilter = function (event, brushFilter, flightLevelOnly) {
    if (visibilityManager.isFlightLevelChartVisible() && brushFilter && _.indexOf(['legs', 'cabin', 'dateRange', 'season', 'dow'], brushFilter.filterType) > -1) {
      var dateRangeBrush = visibilityManager.getAppliedBrushed().dateRange;
      if (dateRangeBrush) {
        scope.selectedDate = rmMomentFormat(rangesCalculatorService.extractDateFromFilter(dateRangeBrush.filterArguments), 'DATE_USER_SETTINGS');
      }

      //if leg with one flight is selected then click on that flight
      scope.reloadChart().then(function () {
        scope.handleBrushEnd(false, false, flightLevelOnly);
      });
    }
  };
  scope.$on('search-criteria:searchChangeEvent', function () {
    scope.mode = currentStateCriteriaService.isPostDeparture() ? 'cabin-post-departure' : scope.mode;
    scope.metrics = analysisMetric.getMetricValues(scope.mode);
  });
  modesToListen.forEach(function (mode) {
    scope.$on(mode.event + ':metricChanged', function (e, metric) {
      scope.mode = mode.modeName;
      scope.metrics = analysisMetric.getMetricValues(mode.modeName, metric);
      scope.selectedMetric = _.find(labels, {
        id: metric
      });
      var brushes = getDataRetriever().brushFilters();
      var legBrush = brushes && brushes.legs;
      if (!legBrush || Array.isArray(legBrush.barsWithData) && legBrush.barsWithData.length === 1) {
        scope.reloadChart();
      }
    });
  });
  scope.handleBrushEnd = function (triggerDefault, clearDefault, silent) {
    var brushFilter = new BrushSelectionFilter(scope.brushFilterType, getFilterParameters());
    brushFilter.barsWithData = getFilterParameters();
    brushFilter.secondaryData = getFilterParameters(['departureTimeMoment', 'flightId', 'leg', 'carrier', 'legDepartureDateMoment', 'flightNumber']);
    brushFilter.barCount = scope.data ? scope.data.length : 0;
    if (!silent) {
      scope.$emit('brush-filter:filterApplied', brushFilter);
    }

    // need to trigger default event for saving default brush
    // only on chart brush actions
    if (triggerDefault) {
      triggerDefaultBrushEvent(clearDefault);
    }
  };
  function areAllNonLYElementsIncludedAndDataContainsLY(val) {
    return val[1] - val[0] === scope.data.length - 1 && _.last(scope.data).isLastYearData;
  }
  function includeLYIntoReturnedResults(values) {
    if (areAllNonLYElementsIncludedAndDataContainsLY(values)) {
      values[1]++;
    }
  }
  function getFilterParams(values, params) {
    if (values.length !== 2) {
      return;
    }
    var mappingFunc = function mappingFunc(el) {
      return _.pick(el, params);
    };
    var mapping = params ? mappingFunc : 'label';
    includeLYIntoReturnedResults(values);
    return _.map(scope.data.slice(values[0], values[1]), mapping);
  }
  function getFilterParameters(params) {
    var rangesSize = _.reduce(scope.ranges, function (size, range) {
      return size + range[1] - range[0];
    }, 0);
    return Array.isArray(scope.data) && rangesSize > 0 ? _.chain(scope.ranges).map(function (range) {
      range = range.map(function (entry) {
        return Math.ceil(entry);
      });
      return getFilterParams(range, params);
    }).flatten().value() : [];
  }
  function getDataRetriever() {
    return dataRetrieverService.getDataRetriever(scope.screen, scope.mode);
  }
  scope.chartFormatters = {
    xAxisTickFormatter: formatterService.identity,
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmNumberFormat(d, representationService.getYAxisFormat(scope.screenState.dataRepresentation));
    },
    tooltipFormatter: function tooltipFormatter(d) {
      var tooltipModel = representationService.prepareTooltipModel(scope.metrics, d, {
        label: d.isLastYearData ? 'LAST YEAR FLIGHTS<br>NOT OPERATING THIS YEAR' : d.flightLabel,
        representation: scope.screenState.dataRepresentation,
        selectedReference: scope.screenState.selectedReference,
        postDeparture: currentStateCriteriaService.isPostDeparture()
      }, scope.screen);
      return tooltipFlightTemplate(tooltipModel);
    }
  };
  scope.chartFormatters.tooltipFormatter.cssClass = 'flight-analysis-thematic-range-chart';
  scope.updateData = function (data) {
    scope.data = data;
    return data;
  };
  scope.restoreSelection = function (brush) {
    var range;
    if (brush) {
      brush = brush.filterArguments[0];
      var lastYearItem = _.find(scope.data, {
        isLastYearData: true
      });
      var data = _.map(scope.data, 'label');
      //get smallest available selection range
      var selection = _.intersection(data, brush);
      var onlyLastYearInIntersection = selection.length === 1 && lastYearItem && selection[0] === lastYearItem.label;
      if (selection.length > 0 && !onlyLastYearInIntersection) {
        var start = _.findIndex(scope.data, {
          'label': _.head(selection)
        });
        var end = _.findIndex(scope.data, {
          'label': _.last(selection)
        }) + 1;
        range = [start, end];
      }
    }
    if (range !== undefined || scope.data.length !== 0) {
      scope.setSelection(range);
    }
  };
  function triggerDefaultBrushEvent(clearDefaultBrush) {
    var brushFilter = new BrushSelectionFilter(scope.brushFilterType, getFilterParameters());
    brushFilter.barsWithData = getFilterParameters();
    brushFilter.clear = clearDefaultBrush;
    scope.$emit('brush-filter:defaultBrush', brushFilter);
  }
  function filterOutLastYearBarBeforeRender(data) {
    return _.filter(data, function (element) {
      return !element.isLastYearData;
    });
  }
  scope.reloadChart = function () {
    scope.setLoadingMessage();
    return dataProviderService.getData(scope.screen, scope.mode, 'flight-level-chart', scope.selectedMetric.id, scope.screenState.dataRepresentation).then(scope.updateData).then(filterOutLastYearBarBeforeRender).then(scope.renderChart).then(function () {
      //restore previous selection
      var flightLevelBrush = visibilityManager.getAppliedBrushed().flightLevel;
      scope.restoreSelection(flightLevelBrush);
      return triggerDefaultBrushEvent();
    });
  };
  scope.onDataRepresentationChange = function () {
    if (visibilityManager.isFlightLevelChartVisible()) {
      scope.reloadChart();
    }
  };
  scope.$watch('screenState.selectedReference', scope.onDataRepresentationChange);
  function onScenariosChanged() {
    dataProviderService.getData(scope.screen, scope.mode, 'flight-level-chart', scope.selectedMetric.id, scope.screenState.dataRepresentation).then(scope.updateData).then(filterOutLastYearBarBeforeRender).then(scope.renderChart);
  }
  scope.calculateSelectionRanges = function (range) {
    var resultRange = [];
    var maxRangeValue = _.last(scope.data).isLastYearData ? scope.data.length - 1 : scope.data.length;
    if (range) {
      resultRange.push(range[0], range[1]);
      if (_.last(scope.data).isLastYearData && range[1] > maxRangeValue) {
        resultRange[1] = maxRangeValue;
      }
    } else {
      resultRange.push(0, maxRangeValue);
    }
    scope.ranges = [resultRange];
    return resultRange;
  };
  scope.onScenariosChanged = onScenariosChanged;
};
FlightLevelChartController.$inject = ['$scope', 'BrushSelectionFilterFactory', 'AnalysisMetricService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'RangesCalculatorService', 'FlightLevelChartDataProviderService', '$filter', 'FormatterService', 'FlightComponentVisibilityManagerService', 'CurrentStateCriteriaService', 'DataRepresentationService'];
module.exports = FlightLevelChartController;